import { notification } from 'antd'
import { stakeholderService } from '../services'
import i18nextConfig from '../../../config/i18next'

const updateUserPortal = (country, rut, nombre, email, passwordCurrent, passwordNew, passwordNewConfirm) => {
	return new Promise((resolve, reject) => {
		stakeholderService.updateUserPortal(country, rut, nombre, email, passwordCurrent, passwordNew, passwordNewConfirm)
			.then(response => {
				resolve({ success: true, data: response })
			})
			.catch(error => {
				if (error.response && error.response.status === 500) {
					reject({ success: false, data: error.response.data })
				} else {
					resolve({ success: false, data: error.response })
				}
			})
	})
}

export default updateUserPortal

